// extracted by mini-css-extract-plugin
export default {"loader":"LoaderDark_loader__TR8Va","loader__logo":"LoaderDark_loader__logo__LGSlH","logo-anim":"LoaderDark_logo-anim__VJXOE"};